document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  // menu interactions
  var menu_toggles = document.querySelectorAll('.js-menu-toggle');
  var menu_target = document.getElementById('site-navigation');

  // sliders
  var sliderEls = document.querySelectorAll('.js-slider');

  // modals
  var modalEls = document.querySelectorAll('.js-modal');
  var modalsOpeners = document.querySelectorAll('.js-open-modal');
  var modalClosers = document.querySelectorAll('.js-close-modal');

  // waypoints
  var animatingEls = document.querySelectorAll('.js-anim');

  // forms
  var formEls = document.querySelectorAll('.js-form');
  var dataMatching = Array.prototype.slice.apply(document.querySelectorAll('a[href="#emailMarketingConsent"]'));
  var partnerLink = Array.prototype.slice.apply(document.querySelectorAll('a[href="#partnerCompanies"]'));
  var datePicker = document.querySelector('.js-datepicker');
  var fullEweChecker = document.querySelector('#allMarketingConsent');

  // consent form toggle
  var choiceEls = document.querySelectorAll('.js-choice');
  var choicesSection = document.getElementById('choices');
  var choiceInput = document.getElementById('choice');

  var inviewEvent = new Event('inview');

  var videoLoop = Array.prototype.slice.apply(document.querySelectorAll('.video-loop'));

  // copy link
  var copyLinks = document.querySelectorAll('.js-copy-link');

  // eventListener - timeupdate: track video progress and remove listener at 50%
  var trackVideoProgress = function (event) {
    var percentageComplete = (event.target.currentTime / event.target.duration) * 100;

    if (percentageComplete >= 50) {
      dataLayer.push({
        'event': 'video',
        'videostatus': '50',
        'attributes.videoUrl': event.target.src
      });

      event.target.removeEventListener('timeupdate', trackVideoProgress);
    }
  };

  // keep navigation height for mobile
  var setNavHeight = function () {
    menu_target.style.height = window.innerHeight + 'px';
  };
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setNavHeight, 300);
  }, false);
  window.addEventListener('load', setNavHeight, false);
  setNavHeight();

  // toggle menus when toggle is clicked
  menu_toggles.forEach(function (menuToggle) {
    menuToggle.addEventListener('click', function () {

      document.body.classList.toggle('has-modal');
      document.querySelector('.site-header__toggle').classList.toggle('is-active');
      menu_target.classList.toggle('is-active');
    });
  });

  // attach events to sliders
  sliderEls.forEach(function (slider_el) {
    var slider_obj;
    var slider_timer;
    var nav_els = slider_el.querySelectorAll('.js-slider__nav a');
    var autoplay = slider_el.hasAttribute('data-autoplay')
      ? parseInt(slider_el.getAttribute('data-autoplay'))
      : false;

    if (
      slider_el.classList.contains('slider--simple')
      || slider_el.classList.contains('slider--highlights')
    ) {
      var slider_timer;
      var slide_els = slider_el.querySelectorAll('.js-slider__slide');

      if (autoplay) {

        var next_index = 1;

        slide_els[0].classList.add('is-active');

        slider_timer = setInterval(function () {
          'use strict';

          slide_els.forEach(function (slide_el, index) {
            slide_el.classList.toggle('is-active', index === next_index);
          });

          next_index = (next_index + 1) > (slide_els.length - 1) ? 0 : next_index + 1;
        }, autoplay);
      }
    } else {
      var target_el = slider_el.querySelector('.slider__slides')
        ? slider_el.querySelector('.slider__slides')
        : slider_el;

      slider_obj = new Siema({
        selector: target_el,
        duration: 350,
        draggable: true,
        loop: true,
        onInit: function () {
          nav_els.forEach(function (nav_el, nav_index) {
            nav_el.addEventListener('click', function (event) {
              event.preventDefault();
              // stop autoplay
              autoplay = false;
              clearInterval(slider_timer);

              slider_obj.goTo(nav_index);

              nav_els.forEach(function (nav_el, index) {
                nav_el.classList.toggle('is-active', index === nav_index);
              });
            });
          });
        },
        onChange: function () {
          nav_els.forEach(function (nav_el, index) {
            nav_el.classList.toggle('is-active', index === slider_obj.currentSlide);
          });

          if (autoplay) {
            clearInterval(slider_timer);
            slider_timer = setInterval(function () {
              slider_obj.next();
            }, autoplay);
          }
        },
      });

      // Adjust slider to react only window resize event, if window width is changed.
      // Otherwise react this event, when user scroll on mobile/tablet and the URL comes and goes.
      var lastWinW = window.innerWidth;
      window.removeEventListener('resize', slider_obj.resizeHandler);
      window.addEventListener('resize', function () {
        if (lastWinW !== window.innerWidth) {
          slider_obj.resizeHandler();
          lastWinW = window.innerWidth;
        }
      });

      if (autoplay) {
        slider_el.addEventListener('inview', function (event) {
          slider_timer = setInterval(function () {
            slider_obj.next();
          }, autoplay);
        }, {once: true});

      }
    }
  });

  // attach events to modal openers
  modalsOpeners.forEach(function (opener_el) {
    opener_el.addEventListener('click', function (event) {
      event.preventDefault();

      var target_modal = document.querySelector(opener_el.hash);

      document.body.classList.add('has-modal');
      target_modal.classList.add('is-active');

      // swap video src, play video, and add listeners to modal for video
      if (target_modal.classList.contains('modal--video')) {
        var closer_el = target_modal.querySelector('.js-close-modal');
        var video_url = opener_el.getAttribute('data-video');
        var target_video = target_modal.querySelector('video');

        target_video.src = video_url;
        target_video.play();

        dataLayer.push({
          'event': 'video',
          'videostatus': '0',
          'attributes.videoUrl': target_video.src
        });

        target_video.addEventListener('timeupdate', trackVideoProgress);

        // stop background video on page
        videoLoop.forEach(function (v) {
          v.pause();
        });

        // add listeners for the end of the video or closing of fullscreen on mobile
        ['ended', 'webkitendfullscreen'].forEach(function (event_name) {
          target_video.addEventListener(event_name, function () {

            if (event_name === 'ended') {
              dataLayer.push({
                'event': 'video',
                'videostatus': '100',
                'attributes.videoUrl': target_video.src
              });
            }

            closer_el.click();
          });
        });
      }
    });
  });

  // attach events to modal openers
  modalClosers.forEach(function (closer_el) {
    closer_el.addEventListener('click', function (event) {
      event.preventDefault();

      document.body.classList.remove('has-modal');

      modalEls.forEach(function (modal_el) {
        modal_el.classList.remove('is-active');

        if (modal_el.classList.contains('modal--video')) {
          modal_el.querySelector('video').pause();
          videoLoop.forEach(function (v) {
            v.play();
          });
        }
      });
    });
  });

  ////
  // Setup an observer to toggle "is-animating" class
  var observer = new IntersectionObserver(function (sentinels) {
    sentinels.forEach(function (sentinel) {
      if (sentinel.isIntersecting) {
        sentinel.target.dispatchEvent(inviewEvent);
        sentinel.target.classList.add('is-animating');
      }
    });
  }, {threshold: [0.3, 1]});

  // attach observer to sticky sentinel elements
  animatingEls.forEach(function (waypoint_el) {
    observer.observe(waypoint_el);
  });

  choiceEls.forEach(function (choice_el) {
    choice_el.addEventListener('change', function () {
      choicesSection.classList.remove('has-error');
      choiceInput.value = choice_el.value;
    });
  });

  ////
  // Expand target element on click
  if (dataMatching.length) {
    dataMatching.forEach(function (dm) {
      dm.addEventListener('click', function (event) {
        event.preventDefault();

        var consentEls = document.querySelectorAll('.contact__consent');
        consentEls.forEach(function (consent_el) {
          consent_el.classList.toggle('is-expanded');
        });
      });
    });
  }

  // Link to partner page
  if (partnerLink.length) {
    partnerLink.forEach(function (l) {
      l.addEventListener('click', function (event) {
        event.preventDefault();
        window.open('/partner_companies', '_blank');
      });
    });
  }

  // Toggle all CEP checkboxes
  if (fullEweChecker) {
    fullEweChecker.addEventListener('change', () => {
      Array.prototype.slice.apply(document.querySelectorAll('.part-ewe input[type="checkbox"]'))
        .forEach(function (ch) {
          ch.checked = fullEweChecker.checked;
        });
    }, false);
  }

  if (datePicker) {
    var max_date = new Date();
    max_date.setFullYear(max_date.getFullYear() - 18);

    flatpickr(datePicker, {
      dateFormat: 'd.m.Y',
      maxDate: max_date,
      allowInput: true,
      disableMobile: true
    });
  }

  //
  // attach handlers to form submissions
  formEls.forEach(function (form_el) {
    var messageEl = form_el.querySelector('.form__message');
    var submitButton = form_el.querySelector('[type=submit]');
    var contactText = document.querySelector('.contact__text');
    var captchaWrapperEl = document.querySelector('.contact__captcha');

    if (form_el['nonce']) {
      var nonceXhr = new XMLHttpRequest();
      nonceXhr.addEventListener('load', function () {
        var response = JSON.parse(nonceXhr.responseText);
        form_el['nonce'].value = response.nonce;
      });
      nonceXhr.open('GET', '/get-nonce?' + new Date().getTime(), true);
      nonceXhr.send('');
    }

    submitButton.addEventListener('click', function (event) {
      var captchaInput = document.getElementById('g-recaptcha-response');

      if (choiceInput && !choiceInput.value.trim()) {
        event.preventDefault();

        choicesSection.classList.add('has-error');
        choicesSection.scrollIntoView({behavior: 'smooth'});

      } else if (captchaInput && captchaInput.value === '') {
        event.preventDefault();

        captchaWrapperEl.classList.add('has-error');
      } else {
        form_el.classList.add('has-submitted');
      }

      // Trigger blur event to run self validation of MDC inputs
      Array.prototype.slice.apply(document.querySelectorAll('.mdc-text-field__input')).forEach(function (el) {
        el.dispatchEvent(new Event('blur'));
      });
    });

    // Tracking raffle start
    if (form_el['page'].value !== 'newsletter') {
      dataLayer.push({
        'event': 'raffle',
        'rafflestatus': 'start'
      });
    }

    form_el.addEventListener('submit', function (event) {
      event.preventDefault();

      var data = new FormData(form_el);

      var eweEmail = form_el.elements['emailMarketingConsent'];
      if (eweEmail.checked) {
        [
          'emailMarketingConsent',
          'postalDeliveryConsent',
          'personalAdConsent',
          'dataMatchingConsent'
        ].forEach((consent) => {
          data.set(consent, form_el.elements[consent] && form_el.elements[consent].checked ? 1 : 0);
        });
      } else {
        fullEweChecker.parentNode.parentNode.classList.add('error');
        eweEmail.parentNode.parentNode.classList.add('error');

        return false;
      }

      Array.prototype.slice.apply(document.querySelectorAll('.contact__consent.error')).forEach(function (consent) {
        consent.classList.remove('error');
      });

      var xhr = new XMLHttpRequest();

      form_el.classList.add('is-loading');

      xhr.open('POST', form_el.action, true);
      xhr.send(data);

      xhr.addEventListener('load', function () {
        var response = JSON.parse(xhr.responseText);

        form_el.classList.remove('is-loading');

        if (xhr.status !== 200 || !response || response.success !== true) {
          messageEl.innerHTML = response.hasOwnProperty('message')
            ? response.message : 'Default error';

          if (document.getElementById('g-recaptcha-response')) {
            grecaptcha.reset();
          }

          form_el.classList.add('has-message');
          var msgRect = messageEl.getBoundingClientRect();
          window.scrollTo(0, window.scrollY + msgRect.top - 120)
          //messageEl.scrollIntoView({behavior: "smooth"});
        } else {
          if (response.hasOwnProperty('redirect') && response.redirect) {
            window.location = response.redirect;
          } else {
            form_el.classList.remove('has-message');
            form_el.classList.add('has-success');

            if (contactText) {
              contactText.innerHTML = '<strong>Vielen Dank!</strong><br>Die Angaben wurden übermittelt. Bitte bestätige deine Anmeldung, indem du auf den Link in der E-Mail klickst, die wir dir soeben zugeschickt haben.'
              window.scrollTo(0, 0);
            }

            var successMsg = document.querySelector('.raffle-success-msg');
            if (successMsg) {
              const formRect = form_el.getBoundingClientRect();
              window.scrollTo(0, window.scrollY + formRect.top - 120);
            }
          }

          // Tracking
          if (data.get('page') !== 'newsletter') {
            dataLayer.push({
              'event': 'raffle',
              'rafflestatus': 'end'
            });
          }

          window.dispatchEvent(new Event('jsFormSuccess'));
        }
      });

    });
  });

  copyLinks.forEach(function (copy_el) {
    var textareaEl = copy_el.querySelector('.js-copy-link__textarea');

    copy_el.addEventListener('click', function (event) {
      event.preventDefault();

      textareaEl.select();

      try {
        var status = document.execCommand('copy');
        if (!status) {
          console.error('Cannot copy text');
        } else {
          console.log('The text is now on the clipboard');
        }
      } catch (err) {
        console.log('Unable to copy.');
      }
    });
  });

  // videoButtonEls.forEach(function (video_button_el) {
  //     video_button_el.addEventListener("click", function (event) {
  //         event.preventDefault();

  //         var video_url = video_button_el.getAttribute("data-video");
  //         var target_modal = document.querySelector(video_button_el.hash);

  //         target_modal.querySelector("video").src = video_url;
  //     });
  // });

  // Re-open cookie-consent
  Array.prototype.slice.apply(document.querySelectorAll('.recall-cookie-consent')).forEach(function (b) {
    b.addEventListener('click', function () {
      Cookiebot.show();
    });
  });

  // Scroll to cookie-consent table, when it's loaded
  const cookieListTable = document.querySelector('#cookieInformation');
  if (cookieListTable && location.hash.length) {
    const cookieListTableAnchorTarget = document.querySelector(location.hash);
    if (cookieListTableAnchorTarget) {
      let cookieListTableContentCheckTimer;
      const checkCookieListTableContent = () => {
        if (cookieListTable.innerText.trim().length) {
          clearInterval(cookieListTableContentCheckTimer);
          const cookieListTableAnchorTargetRect = cookieListTableAnchorTarget.getBoundingClientRect();
          const siteHeaderH = document.querySelector('.site-header').offsetHeight;
          window.scrollTo(0, Math.round(window.scrollY + cookieListTableAnchorTargetRect.top) - siteHeaderH - 32);
        }
      }
      cookieListTableContentCheckTimer = setInterval(checkCookieListTableContent, 150);
    }
  }

  // Load random logos, if container element is found
  const logoListWrapper = document.querySelector('.logo-list-wrapper');
  if (logoListWrapper) {
    var shopListXhr = new XMLHttpRequest();
    var shopsLimit = logoListWrapper.dataset.limit ? logoListWrapper.dataset.limit : 0;
    shopListXhr.open('GET', '/get-shops?t=' + new Date().getTime() + '&limit=' + shopsLimit, true);
    shopListXhr.addEventListener('load', function () {
      var shops = JSON.parse(shopListXhr.responseText);
      var shopsHtml = '';

      shops.forEach((shop, i) => {
        shopsHtml +=
          '<li class="shop anim fade-bottom d-' + (150 + (100 * i)) + '">' +
          '<h3 class="shop__title">' +
          '<span class="screen-reader-text">' + shop.name + '</span>' +
          '<img class="shop__image" alt="' + shop.alt + '" src="/assets/images/shop/' + shop.image + '" srcset="/assets/images/shop/' + shop.image_hq + ' 2x">' +
          '</h3>' +
          '<a class="shop__button" href="' + shop.url + '" target="_blank" onclick="dataLayer.push({\'event\':\'customClick\', \'clickName\': \'' + shop.name + '\', \'clickURL\': \'' + shop.url + '\'});">Zum Shop</a>' +
          '</li>';
      });


      logoListWrapper.innerHTML = shopsHtml;

      if (logoListWrapper.classList.contains('is-animating')) {
        logoListWrapper.classList.remove('is-animating');

        setTimeout(function () {
          logoListWrapper.classList.add('is-animating');
        }, 400);
      }
    });
    shopListXhr.send();
  }

  // Form
  Array.prototype.slice.apply(document.querySelectorAll('.select-input')).forEach(function (el) {
    NiceSelect.bind(el, {placeholder: 'Anrede'});
  });

  Array.prototype.slice.apply(document.querySelectorAll('.mdc-text-field')).forEach(function (el) {
    new mdc.textField.MDCTextField(el);
  });

  Array.prototype.slice.apply(document.querySelectorAll('.mdc-select')).forEach(function (el) {
    new mdc.select.MDCSelect(el);
  });
});

// Homepage teaser
window.addEventListener('load', function () {
  var recipesTeaser = document.querySelector('.recipe-teaser');
  if (recipesTeaser) {
    var rtGalItems = Array.prototype.slice.apply(recipesTeaser.querySelectorAll('.recipe-teaser__img-item'));

    if (rtGalItems.length) {
      var rtGalInterval = 3000;
      var rtGalAnimDur = 700;
      var rtGalCurrIdx = 0;

      function rtGalSwitch() {
        var rtGalNexIdx = rtGalCurrIdx + 1;
        if (rtGalNexIdx >= rtGalItems.length) {
          rtGalNexIdx = 0;
        }

        rtGalItems[rtGalCurrIdx].classList.add('inactive');
        setTimeout(function () {
          rtGalItems[rtGalNexIdx].classList.remove('inactive');
          rtGalCurrIdx = rtGalNexIdx;
          setTimeout(rtGalSwitch, rtGalInterval);
        }, rtGalAnimDur);
      }

      setTimeout(rtGalSwitch, rtGalInterval);
    }
  }
});

(function () {
  var countDown = document.querySelector('.my-countdown');

  if (countDown) {
    var daySec = 60 * 60 * 24 * 1000,
      hourSec = 60 * 60 * 1000,
      minSec = 60 * 1000,
      countDownEnd = new Date(countDown.dataset.end).getTime(),
      countDownD = document.createElement('div'),
      countDownH = document.createElement('div'),
      countDownM = document.createElement('div'),
      countDownSpacer1 = document.createElement('div'),
      countDownSpacer2 = document.createElement('div');

    function displayIceSlide() {
      location.href = docRoot;
    }

    function initCountDown() {
      countDownD.setAttribute('class', 'my-countdown__counter');
      countDownH.setAttribute('class', 'my-countdown__counter');
      countDownM.setAttribute('class', 'my-countdown__counter');
      countDownSpacer1.setAttribute('class', 'my-countdown__counter');
      countDownSpacer2.setAttribute('class', 'my-countdown__counter');

      countDown.appendChild(countDownD);
      countDown.appendChild(countDownSpacer1);
      countDown.appendChild(countDownH);
      countDown.appendChild(countDownSpacer2);
      countDown.appendChild(countDownM);

      countDownSpacer1.innerHTML = countDownSpacer2.innerHTML = '<p class="my-countdown__time">:</p>';

      updateCountDown();
    }

    function updateCountDown() {
      var now = new Date().getTime(),
        timerDiff = countDownEnd - now;

      if (timerDiff <= 0) {
        countDownD.innerHTML = '<p class="my-countdown__time">00</p><p class="my-countdown__label">Tag</p>';
        countDownH.innerHTML = '<p class="my-countdown__time">00</p><p class="my-countdown__label">Std</p>';
        countDownM.innerHTML = '<p class="my-countdown__time">00</p><p class="my-countdown__label">Min</p>';

        if (countDown.classList.contains('ice-countdown')) {
          displayIceSlide();
        }
      } else {
        var dayNum = Math.floor(timerDiff / daySec),
          hourNum = Math.floor(timerDiff % daySec / hourSec),
          minNum = Math.ceil(timerDiff % hourSec / minSec);

        if (60 === minNum) {
          // 00:00:60 should be 00:01:00
          minNum = 0;
          hourNum += 1;
        }

        if (24 === hourNum) {
          // 00:24:00 should be 01:00:00
          hourNum = 0;
          dayNum += 1;
        }

        var dayLabel = 1 < dayNum ? "Tage" : "Tag",
          // hLabel = 1 < hourNum ? "Stunden" : "Stunde",
          hLabel = 'Std.',
          // mLabel = 1 < minNum ? "Minuten" : "Minute";
          mLabel = 'Min.';

        countDownD.innerHTML = '<p class="my-countdown__time">' + getCountdownNum(dayNum) + '</p><p class="my-countdown__label">' + dayLabel + '</p>';
        countDownH.innerHTML = '<p class="my-countdown__time">' + getCountdownNum(hourNum) + '</p><p class="my-countdown__label">' + hLabel + '</p>';
        countDownM.innerHTML = '<p class="my-countdown__time">' + getCountdownNum(minNum) + '</p><p class="my-countdown__label">' + mLabel + '</p>';

        window.requestAnimationFrame(updateCountDown);
      }
    }

    function getCountdownNum(num) {
      return ('00' + num).slice(-2);
    }

    window.addEventListener('load', initCountDown);
  }
})();

window.addEventListener('load', function () {
  var loopVideos = Array.prototype.slice.apply(document.querySelectorAll(".video-loop"));
  if (loopVideos.length) {
    // place fallback image, if autoplay is denied
    var promise = loopVideos[0].play();
    if (promise !== undefined) {
      promise.catch(() => {
        loopVideos.forEach(function (v) {
          var wrapper = v.parentNode;
          var fallback = wrapper.dataset.fallback;
          var fallbackDesktop = wrapper.dataset.fallbackDesktop;
          var fallbackImageInner = '';

          if (fallbackDesktop) {
            fallbackImageInner += '<source srcset="' + fallbackDesktop + '" media="(min-width: 768px)" />';
          }

          if (fallback) {
            fallbackImageInner += '<img class="video-fallback" src="' + fallback + '" alt="Video fallback" />';
          }
          console.log(fallbackImageInner)
          if (fallbackImageInner.length) {
            var fallbackImage = document.createElement('picture');
            fallbackImage.innerHTML = fallbackImageInner;
            wrapper.appendChild(fallbackImage);
            v.style.display = 'none';
          } else {
            v.setAttribute('controls', 'controls');
          }
        });
      });
    }

  }
}, false);

/**
 * Masked Video
 */
const maskedVideos = Array.prototype.slice.apply(document.querySelectorAll('.masked-video'));
if (maskedVideos.length) {
  const canvasSize = 600;
  const maskSize = 599;
  const items = maskedVideos.map(item => {
    const cnvs = document.createElement('canvas');
    cnvs.width = canvasSize;
    cnvs.height = canvasSize;
    item.appendChild(cnvs);

    return {
      wrapper: item,
      ctx: cnvs.getContext('2d'),
      video: item.querySelector('.masked-video__video'),
      fallback: item.querySelector('.masked-video__fallback'),
      mask: item.querySelector('.masked-video__mask'),
    };
  });

  const drawMaskedVideos = () => {
    items.forEach((item) => {
      item.ctx.globalCompositeOperation = 'source-over';

      if (item.video.paused) {
        item.ctx.drawImage(item.fallback, 0, 0, canvasSize, canvasSize);
      } else {
        item.ctx.drawImage(item.video, 0, 0, canvasSize, canvasSize);
      }

      let distW, distH;
      if (item.mask.offsetWidth < item.mask.offsetHeight) {
        distH = maskSize;
        distW = distH * (item.mask.offsetWidth / item.mask.offsetHeight);
      } else {
        distW = maskSize;
        distH = distW * (item.mask.offsetHeight / item.mask.offsetWidth);
      }

      item.ctx.globalCompositeOperation = 'destination-in';
      item.ctx.drawImage(item.mask, 0, 0, distW, distH);
    });

    window.requestAnimationFrame(drawMaskedVideos);
  }

  if (document.readyState === 'complete') {
    drawMaskedVideos();
  } else {
    window.addEventListener('load', drawMaskedVideos);
  }
}

/**
 * Hint reveal image
 */
const revealBtn = document.querySelector('.raetsel-main .reveal-btn');
if (revealBtn) {
  revealBtn.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.raetsel-main__quiz').classList.add('show-hint');
    document.querySelector('.wer-bin-ich').style.opacity = 0;
  });
}

/**
 * Coming soon bg
 */
const csbg = document.querySelector('.raetsel-coming-soon__bg');
if (csbg) {
  const cnvs = document.createElement('canvas');
  cnvs.width = 4160;
  cnvs.height = 2254;
  csbg.appendChild(cnvs);
  const ctx = cnvs.getContext('2d');
  const bg = csbg.querySelector('.bg');
  const mask = csbg.querySelector('.mask');

  const drawComingSoonBg = () => {
    const viewportH = (cnvs.height -Math.min(cnvs.height, window.innerWidth * 0.5418)) / 6;

    ctx.drawImage(bg, 0, -viewportH, cnvs.width, cnvs.height);
    ctx.globalCompositeOperation = 'destination-in';
    ctx.drawImage(mask, 0, 0, cnvs.width, cnvs.height);
  };

  if (document.readyState === 'complete') {
    drawComingSoonBg();
  } else {
    window.addEventListener('load', drawComingSoonBg);
  }
}

(function () {
  var participationCounter = document.querySelector('.participation-counter');
  if (participationCounter) {
    function fillCounter(num) {
      var count = String(num).padStart(5, '0');
      participationCounter.querySelectorAll('.participation-counter__num').forEach(function (el, i) {
        el.innerText = count.charAt(i);
      });
    }

    var time = Math.floor(new Date().getTime() / 60000);
    var xhr = new XMLHttpRequest();
    xhr.open("GET", '/get-fineschlecker-count?t=' + time, true);
    xhr.addEventListener("load", function () {
      var count = JSON.parse(xhr.responseText);
      if (typeof count === 'number' && count > 0) {
        fillCounter(count);
      } else {
        // No more participation available
        fillCounter(0);
      }
    });
    xhr.send();
  }
})();